import { getDefaultValue } from '@tencent/data-schema-core';
import { fromJsonData } from '@tencent/data-schema-core/lib/convertor/jsonData';
export function isSchema(s) {
  return s && typeof s === 'object' && typeof s.type === 'string';
}
export function pickSchema(...data) {
  return data.find(item => isSchema(item)) || null;
}
/**
 * 遍历每个schema的节点 包括 items
 * @param schema
 * @param fn
 * @returns
 */
export function schemaEach(schema, fn) {
  if (!schema) return;
  fn(schema);
  if (schema.type === 'object' && Array.isArray(schema.fields)) {
    schema.fields.forEach(item => {
      schemaEach(item, fn);
    });
  }
  if (schema.type === 'array' && typeof schema.items === 'object') {
    schemaEach(schema.items, fn);
  }
}
/**
 * 类似Array.proptype.find
 * @param schema
 * @param fn
 * @returns
 */
export function schemaFind(schema, fn) {
  if (!schema) return null;
  if (fn(schema)) {
    return schema;
  }
  if (schema.type === 'object' && Array.isArray(schema.fields)) {
    const target = schema.fields.find(item => schemaFind(item, fn));
    return target || null;
  }
  if (schema.type === 'array' && typeof schema.items === 'object') {
    return schemaFind(schema.items, fn);
  }
  return null;
}
/**
 * 遍历每个schema的节点 包括 items
 * @param schema
 * @param fn
 * @returns
 */
export function schemaEachWithPath(schema, fn, path = '') {
  if (!schema) return;
  fn({
    schema,
    dataPath: path
  });
  if (schema.type === 'object' && Array.isArray(schema.fields)) {
    schema.fields.forEach(item => {
      const id = String(item.id || 'unknown');
      schemaEachWithPath(item, fn, path ? `${path}.${id}` : id);
    });
  }
  if (schema.type === 'array' && typeof schema.items === 'object') {
    schemaEachWithPath(schema.items, fn, path ? `${path}.[0]` : '[0]');
  }
}
export function schemaFindWithPath(schema, fn, ignore) {
  if (!schema) return null;
  let target = null;
  const ignoreFn = ignore || (() => false);
  const find = (schema, path = '', parent) => {
    const isIgnore = ignoreFn(schema);
    if (isIgnore) {
      return false;
    }
    if (fn(schema)) {
      target = {
        schema,
        dataPath: path,
        parent
      };
      return true;
    }
    if (schema.type === 'object' && Array.isArray(schema.fields)) {
      return schema.fields.some(item => {
        const id = `${item.id || 'unknown'}`;
        return find(item, path ? `${path}.${id}` : id, {
          schema,
          dataPath: path
        });
      });
    }
    if (schema.type === 'array' && typeof schema.items === 'object') {
      const dataPath = `${schema.id}.[0]`;
      return find(schema.items, dataPath, {
        schema: schema.items,
        dataPath
      });
    }
    return false;
  };
  find(schema);
  return target;
}
/**
 * 找到fields最多的一个schema
 * @param schema
 * @returns
 */
export function schemaFindMaximumFieldsObject(schema, fn = () => true) {
  let len = 0;
  let target = null;
  schemaEachWithPath(schema, info => {
    var _info$schema$fields;
    const fieldsLength = (_info$schema$fields = info.schema.fields) === null || _info$schema$fields === void 0 ? void 0 : _info$schema$fields.length;
    if (schema.type === 'object' && fieldsLength && fn(info.schema)) {
      if (fieldsLength > len) {
        len = fieldsLength;
        target = info;
      }
    }
  });
  return target;
}
export function getRealQuerySchema(cgiInfo) {
  return pickSchema(cgiInfo === null || cgiInfo === void 0 ? void 0 : cgiInfo.fixedQuerySchema, cgiInfo === null || cgiInfo === void 0 ? void 0 : cgiInfo.querySchema);
}
export function getRealBodySchema(cgiInfo) {
  return pickSchema(cgiInfo === null || cgiInfo === void 0 ? void 0 : cgiInfo.fixedBodySchema, cgiInfo === null || cgiInfo === void 0 ? void 0 : cgiInfo.bodySchema);
}
export function getRealResponseSchema(cgiInfo) {
  return pickSchema(cgiInfo === null || cgiInfo === void 0 ? void 0 : cgiInfo.fixedResponseSchema, cgiInfo === null || cgiInfo === void 0 ? void 0 : cgiInfo.responseSchema);
}
/**
 *  修剪有一版改了，fixedSchema之类的和用户配置的参数不对应，取的是模板的参数，这个方法不靠谱了
 * @param cgiInfo
 * @returns
 */
export function getCgiSchemas(cgiInfo) {
  return {
    querySchema: getRealQuerySchema(cgiInfo),
    bodySchema: getRealBodySchema(cgiInfo),
    responseSchema: getRealResponseSchema(cgiInfo)
  };
}
export function getCgiDefaultParamsValue(collection, cgi) {
  const cgiInfo = collection.cgiInfo[cgi];
  const defaultValue = {
    query: {},
    body: {}
  };
  if (!cgiInfo) {
    return defaultValue;
  }
  const debugParams = cgiInfo.debugParam;
  const querySchema = fromJsonData((debugParams === null || debugParams === void 0 ? void 0 : debugParams.query) || {});
  const bodySchema = fromJsonData((debugParams === null || debugParams === void 0 ? void 0 : debugParams.body) || {});
  return {
    query: getDefaultValue(querySchema, {
      includeOptional: true
    }),
    body: getDefaultValue(bodySchema, {
      includeOptional: true
    })
  };
}
export function getCgiDefaultParamsValueFromHook(collection, cgi) {
  const cgiInfo = collection.cgiInfo[cgi];
  const defaultValue = {
    query: {},
    body: {}
  };
  if (!cgiInfo) {
    return defaultValue;
  }
  const {
    queryHook,
    bodyHook
  } = cgiInfo;
  // 适配函数修剪的改动，没有queryHook和bodyHook了
  if (!queryHook && !bodyHook) {
    var _cgiInfo$debugParam, _cgiInfo$debugParam2;
    return {
      query: {
        ...((_cgiInfo$debugParam = cgiInfo.debugParam) === null || _cgiInfo$debugParam === void 0 ? void 0 : _cgiInfo$debugParam.query)
      },
      body: {
        ...((_cgiInfo$debugParam2 = cgiInfo.debugParam) === null || _cgiInfo$debugParam2 === void 0 ? void 0 : _cgiInfo$debugParam2.body)
      }
    };
  }
  const queryAllSchema = getRealQuerySchema(cgiInfo);
  const bodyAllSchema = getRealBodySchema(cgiInfo);
  try {
    var _cgiInfo$debugParam3;
    const querySchema = getSchemasFromHook(queryHook || [], queryAllSchema);
    const bodySchema = Array.isArray(bodyHook) && bodyHook !== null && bodyHook !== void 0 && bodyHook.length ? getSchemasFromHook(bodyHook || [], bodyAllSchema) : fromJsonData((_cgiInfo$debugParam3 = cgiInfo.debugParam) === null || _cgiInfo$debugParam3 === void 0 ? void 0 : _cgiInfo$debugParam3.body) || {};
    return {
      query: getDefaultValue(querySchema, {
        includeOptional: true
      }),
      body: getDefaultValue(bodySchema, {
        includeOptional: true
      })
    };
  } catch (error) {
    console.error(error);
    return defaultValue;
  }
}
/**
 *从修剪逻辑中取实际前端使用的参数
 */
function getSchemasFromHook(hooks, schema) {
  var _schema$fields;
  const valueKeys = [];
  const walk = v => {
    if (typeof v === 'string') {
      valueKeys.push(v);
    } else if (Array.isArray(v)) {
      v.forEach(item => {
        walk(item);
      });
    }
  };
  hooks.forEach(item => {
    if (item.type === 'variable') {
      walk(item.value);
    }
  });
  // 去重
  const keysSet = new Set(valueKeys);
  const fields = (schema === null || schema === void 0 || (_schema$fields = schema.fields) === null || _schema$fields === void 0 ? void 0 : _schema$fields.filter(item => keysSet.has(String(item.id)))) || [];
  return {
    type: 'object',
    fields
  };
}
/**
 * 打平schema  保留 id type title
 * @param schema
 * @param removeRootId 忽略根节点的id
 * @returns
 */
export function paveSchema(schema, removeRootId = true) {
  var _schema$fields2;
  if (!schema || schema.type !== 'object' || !((_schema$fields2 = schema.fields) !== null && _schema$fields2 !== void 0 && _schema$fields2.length)) {
    return [];
  }
  const res = [];
  const walk = (parent, schema, removeRootId = false) => {
    var _schema$fields3;
    if (schema.type === 'object' && (_schema$fields3 = schema.fields) !== null && _schema$fields3 !== void 0 && _schema$fields3.length) {
      const objectParent = parent.slice();
      if (typeof schema.id === 'string' && !removeRootId) {
        objectParent.push(String(schema.id));
      }
      schema.fields.forEach(s => walk(objectParent, s));
    }
    if (schema.type === 'array') {
      var _schema$items, _schema$items$fields;
      if (((_schema$items = schema.items) === null || _schema$items === void 0 ? void 0 : _schema$items.type) === 'object' && (_schema$items$fields = schema.items.fields) !== null && _schema$items$fields !== void 0 && _schema$items$fields.length) {
        const arrayParent = parent.slice();
        if (typeof schema.id === 'string') {
          arrayParent.push(String(schema.id));
        }
        walk(arrayParent, schema.items);
      }
    }
    if (!removeRootId) {
      res.push({
        id: [...parent, schema.id].join('.'),
        type: schema.type,
        title: schema.title
      });
    }
  };
  walk([], schema, removeRootId);
  return res;
}
//# sourceMappingURL=schemaUtil.js.map
